<template>
    <div class="faq-component-wrap"
         :class="['module-position-' + templateData.module_position]">
        <div class="module-wrap">
            <template v-if="moduleUrl">
                <iframe
                    :src="moduleUrl"
                    class="iframe-on-page close-iframe-on-end"
                    :data-session-finished="sessionFinishedUrl"
                    frameborder="0"
                ></iframe>
            </template>
        </div>
        <div class="accordions">
            <template v-if="this.templateData.template_data.faq_heading">
                <h3 class="faq-heading title-1 wrapped-label gray-900 margin-bottom-4">{{ this.templateData.template_data.faq_heading }}</h3>
            </template>
            <template v-for="(accordion, key) in this.templateData.template_data.faq_content">
                <div class="accordion">
                    <div class="option">
                        <input type="checkbox" :id="['toggle' + key]" class="toggle">
                        <label class="accordion-title" :for="['toggle' + key]">{{ accordion.question }}</label>
                        <div class="accordion-content">
                            <div class="accordion-content-inner" v-html="accordion.answer"></div>
                        </div>
                    </div>
                </div><!--/.accordion-->
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FAQComponent',
    props: {
        templateData: {
            type: Object,
            required: true,
            default: {}
        }
    },
    data() {
        return {
            options: {
                closeButton: false
            }
        }
    },

    computed: {
        sessionFinishedUrl() {
            let queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);

            if(urlParams.get('redirect_uri')) {
                return urlParams.get('redirect_uri');
            }

            if ( this.templateData.template_data.module.result_event == 'close-module' ) {
                return 'close'
            }
            return null
        },
        moduleUrl() {
            if(!this.templateData) return;
            return this.templateData.template_data.module.module_url
        }
    }
}
</script>